import React, { Fragment } from 'react'
import { Route, Routes } from 'react-router-dom'
import { anonymous } from 'routes/config/user'
import AuthRouter from './AuthRouter'

const UserRouter = ({ isAuthenticated,permissions }) => {
  
 


  return (
    <Fragment>
      <Routes>
        {anonymous.map(({ routePath, Component }) => {
          return (
            <Route
              key={routePath}
              path={routePath}
              element={<Component />}
            ></Route>
          )
        })}
      </Routes>
      <AuthRouter isAuthenticated={isAuthenticated} permissions={permissions} />
    </Fragment>
  )
}

export default UserRouter
